import React from 'react';

const AccountSettings = () => {
    return (<div></div>);
}

export default AccountSettings;